import { render, staticRenderFns } from "./FactorTypeEditor.vue?vue&type=template&id=51270b40&scoped=true&"
import script from "./FactorTypeEditor.vue?vue&type=script&lang=ts&"
export * from "./FactorTypeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FactorTypeEditor.vue?vue&type=style&index=0&id=51270b40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51270b40",
  null
  
)

export default component.exports